module.exports = __webpack_public_path__ + "static/img/certificateImg.28190ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo/certificateImg.png
// module id = vc/J
// module chunks = 0